export const addFriendPageUrl = 'https://freezone-s4.firebaseapp.com/redirect/?v=2&data=L0MeDg0HFQYLFTgQCVBbURscEQcaVEhOAgAaCEcDEFs3XCAbShVcQ0FcDx0dVVZeXAxGGQ%3D%3D';

export default {};
